import { useSelector } from "react-redux";
import {
  PlatformFeature,
  SetupType,
} from "../../models/features/Integration/DmsSetup";

export const PlatformFeatureMatrix: Record<PlatformFeature, SetupType[]> = {
  [PlatformFeature.LinkInventory]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],

  [PlatformFeature.VirtualShowroom]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
  ],

  [PlatformFeature.HidePrice]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],

  [PlatformFeature.CustomPriceRule]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],

  [PlatformFeature.LocationMapping]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
  [PlatformFeature.ProductsMatchingWithCatalog]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
  [PlatformFeature.AppHealth]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
  [PlatformFeature.SetupIdSharing]: [SetupType.HiImpact],
  [PlatformFeature.UsedProducts]: [
    SetupType.Shopify,
    SetupType.ShopifyLegacy,
    SetupType.BigCommerce,
  ],
};

export const hasPlatformFeatureAccess = (
  setupType: SetupType | null | undefined,
  feature: PlatformFeature,
): boolean => {
  if (!setupType) return false;
  return PlatformFeatureMatrix[feature]?.includes(setupType) ?? false;
};
